import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../services/user.service';
import { User } from '../../models/core.models';

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrl: './user-profile.component.scss',
    standalone: false
})
export class UserProfileComponent {
  @Input() user: User;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
  ) {}

  ngOnInit() {
    // console.log(this.user);
  }

  loadUser() {
    // this.userService.loadUserProfile(this.userId).subscribe(
    //   user => this.user = user
    // )
  }
}
